/*
 * Copyright (c) 2023, WSO2 LLC (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { FormattedMessage } from 'react-intl';
import { Box } from '@material-ui/core';
import GithubSignupButton from 'modules/signup/buttons/GithubSignupButton';
import GoogleSignupButton from 'modules/signup/buttons/GoogleSignupButton';
import OrDivider from 'components/ChoreoSystem/Authenticate/OrDivider/OrDivider';
import AuthenticationFormCard from 'components/ChoreoSystem/Authenticate/AuthenticationFormCard/AuthenticationFormCard';
import {
  enableGithubSignup,
  enableGoogleSignup,
  enableMicrosoftSignup,
} from 'config';
import EmailSignupButton from '../buttons/EmailSignupButton';
import MicrosoftSignupButton from '../buttons/MicrosoftSignupButton/MicrosoftSignupButton';

interface SignupCardProps {
  isMobile: boolean;
  onEmailClick: () => void;
  onGithubClick: () => void;
  onGoogleClick: () => void;
  onMicrosoftClick: () => void;
}

export default function SignupCard(props: SignupCardProps) {
  const {
    onGithubClick,
    onGoogleClick,
    onMicrosoftClick,
    isMobile,
    onEmailClick,
  } = props;

  return (
    <AuthenticationFormCard
      testId="authenticate-form-card-signup"
      isMobile={isMobile}
      isSignUp
      title={
        <FormattedMessage
          id="modules.signup.signupCard.signup.title"
          defaultMessage="Sign Up"
        />
      }
    >
      <Box>
        <Box mb={1}>
          <GoogleSignupButton
            onClick={onGoogleClick}
            show={enableGoogleSignup === 'true'}
          />
        </Box>
        <Box mb={1}>
          <GithubSignupButton
            onClick={onGithubClick}
            show={enableGithubSignup === 'true'}
          />
        </Box>
        <Box mb={1}>
          <MicrosoftSignupButton
            onClick={onMicrosoftClick}
            show={enableMicrosoftSignup === 'true'}
          />
        </Box>
        <OrDivider
          text={
            <FormattedMessage
              id="modules.signup.signupCard.signupCard.orDivider"
              defaultMessage="OR"
            />
          }
        />
        <Box>
          <EmailSignupButton onClick={onEmailClick} />
        </Box>
      </Box>
    </AuthenticationFormCard>
  );
}
